module.exports = __webpack_public_path__ + "static/media/vials.d39c33ae.svg";